/* eslint-disable jira/filename-case */
import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo/ufo-experimental';
import { createJpdExperience } from './createJpdExperience.tsx';
import type {
	ExperienceErrorReason,
	ExperienceMetadataExtra,
	JPDExperience,
} from './ExperienceMetadataExtra.types.tsx';

export const pageLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.collections', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageLoad,
	}),
);

export const create: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.create', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadCollections: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.load-collections', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadViewCount: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.load-view-count', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadUsers: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.load-users', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadProjects: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.load-projects', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const createCollection: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.create-collection', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const copyCollection: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.copy-collection', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const deleteCollection: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.delete-collection', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const updateCollection: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.update-collection', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadCollection: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.load-collection', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadCollectionViews: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.load-collection-views', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadCollectionDescription: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.collections.load-collection-description', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const updateCollectionDescription: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.collections.update-collection-description', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const createView: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.create-view', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const deleteView: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.collections.delete-view', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);
